module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('span', [_vm._v("We live, as we dream—alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_vm._v("—Joseph Conrad,")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("Heart of Darkness")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f24902d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/franmatter01.vue
// module id = 78
// module chunks = 0